import { spacing } from '@akin-home/theme';
import React from 'react';

import { Pressable, StyleSheet, Text, View } from 'react-native';
import { RobotDevice } from '../../types';
import { getRobotTypeDisplayName } from '../../utils';
import { RobotAvatarBadge } from '../RobotAvatarBadge';
import { RobotConnectionStatusDisplay } from './RobotConnectionStatusDisplay';

interface KnownRobotCardProps {
  robot: RobotDevice;
  onPress?: () => void;
  width?: number | string;
  height?: number | string;
}

export const KnownRobotCard = (props: KnownRobotCardProps) => {
  const { robot, width = 250, height = 108 } = props;

  let avatarSize = 100;
  if (typeof height === 'number') {
    avatarSize = height - spacing[2];
  }

  if (!robot) {
    return null;
  }

  return (
    <View
      style={{
        width: width,
        height: height,
        justifyContent: 'center',
        marginVertical: spacing[2],
      }}
    >
      <Pressable
        style={styles.pressable}
        onPress={() => props.onPress?.()}
        android_ripple={{ color: 'gray', borderless: false }}
        disabled={!props.onPress}
      >
        {/* Avatar */}
        <View style={[styles.avatarContainer, { width: avatarSize }]}>
          <RobotAvatarBadge robotDevice={robot} size={avatarSize} isHollow />
        </View>

        {/* Details */}
        <View style={styles.detailsContainer}>
          <Text style={[styles.textBase, styles.nameText]} numberOfLines={1}>
            {robot.name ?? ''}
          </Text>

          <Text
            style={[styles.textBase, styles.modelText]}
            adjustsFontSizeToFit
            numberOfLines={1}
          >
            {`(${getRobotTypeDisplayName(robot.type ?? '')})`}
          </Text>

          <RobotConnectionStatusDisplay robot={robot} />
        </View>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  pressable: {
    width: '100%',
    flexDirection: 'row',
    padding: spacing[1],
    backgroundColor: 'blanchedalmond',
    elevation: 2,
    borderRadius: 10,
  },
  avatarContainer: {
    aspectRatio: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: spacing[1],
  },
  avatarImage: {
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    alignItems: 'center',
  },
  detailsContainer: {
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: spacing[1],
    flexDirection: 'column',
  },
  textBase: {
    color: 'black',
    textAlign: 'center',
    alignSelf: 'center',
    width: '100%',
  },
  nameText: {
    fontSize: 22,
    paddingTop: spacing[2],
    marginTop: 'auto',
    textTransform: 'capitalize',
  },
  modelText: {
    fontSize: 15,
    fontStyle: 'italic',
  },
});
